import ModalsInfoLib from '../../lib/modals-info';

export default () => {
    return (
        <div className="modal-info-container">
            <div className="modal-info animate__animated animate__fadeInUp animate__faster">
                <div className="close-button" onClick={e => ModalsInfoLib.close()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div className="modal-info-content">
                    <div className="modal-info-image">
                        <img src={`${window.location.origin}/source/system/modal-info/vip-20-monthly-rakeback-info.png`} alt="" />
                    </div>

                    <div className="modal-info-body">
                        <div className="modal-info-body-content">
                            <p>
                                <h1>Monthly Rakeback</h1>

                                <span>Receive a percentage of your monthly net losses based on your current VIP level.</span>
                                <span>Rakeback is calculated automatically and credited on the <b>1st day of each month at 12:00 PM (Los Angeles time)</b>.</span>
                                <span>The calculation period runs from the <b>1st day of the month at 12:00 AM to the last day of the month at 11:59 PM (Los Angeles time)</b>.</span>
                            </p>

                            <p>
                                <h2>Monthly Rakeback Rates by VIP Level</h2>
                                <span>
                                    Silver — <b>5%</b><br/>
                                    Gold — <b>7%</b><br/>
                                    Platinum — <b>10%</b><br/>
                                    Diamond — <b>12%</b><br/>
                                    Elite — <b>15%</b><br/>
                                    <br/>
                                    (Regular and Bronze does not receive Monthly Rakeback.)
                                </span>
                            </p>

                            <p>
                                <h2>How is Monthly Rakeback calculated?</h2>
                                <span>Monthly Rakeback is calculated using the following formula:</span>
                                <span>Net Loss = (Total Deposits − Total Withdrawals − Current Balance)</span>
                                <span>Your rakeback amount = Net Loss × Your VIP Rakeback Percentage.</span>
                            </p>

                            <p>
                                <h2>Are rakeback funds withdrawable?</h2>
                                <span>No. Monthly Rakeback is credited as bonus balance and is not immediately withdrawable.</span>
                                <span>It must be wagered according to the applicable bonus wagering requirements before becoming eligible for withdrawal.</span>
                            </p>

                            <p>
                                <h2>What if I had a profitable month?</h2>
                                <span>If your net result for the month is zero or positive, no rakeback is generated.</span>
                            </p>

                            <p>
                                <h2>Does my VIP level affect it?</h2>
                                <span>Yes. Your rakeback percentage depends on your VIP level at the time of calculation.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-info-overlay animate__animated animate__fadeIn animate__faster"></div>
        </div>
    )
}